import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import Button from '../Button/Button';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Select from '../Select/Select';
import Input from '../Input/Input';
import { Context } from '../Context/withContext';
import { FormDataContext } from '../FormDataContext/WithFormDataContext';
import FormHalfCol from '../FormHalfCol/FormHalfCol';
import FormSection from '../FormSection/FormSection';
import {
  isValidID,
  isValidGender,
  isOver18,
  isValidYAR,
  noWhiteSpace,
} from '../../Utils/ValidationUtils';
import { ethnicGroups } from '../../Data/EthnicGroups';
import { sendFinanceRequest } from './Utils';
// import { PathContext } from '../PathContext/PathContext';
import { defaultValues } from './defaultValues';
import { sendPostMessage } from '../../Utils/postMessage';
import { VehicleApplicationContext } from '../../VehicleApplicationContext/WithVehicleApplicationContext';

yup.addMethod(yup.mixed, 'isValidID', isValidID);
yup.addMethod(yup.mixed, 'isValidGender', isValidGender);
yup.addMethod(yup.mixed, 'isOver18', isOver18);
yup.addMethod(yup.mixed, 'isValidYAR', isValidYAR);
yup.addMethod(yup.mixed, 'noWhiteSpace', noWhiteSpace);

const schema = yup.object().shape({
  title: yup.string().required('Required'),
  first_name: yup
    .string()
    .max(40, 'Cannot be longer than 40 characters')
    .required('Required')
    .matches(/^[A-Za-z0-9 ]+$/, 'Cannot contain special characters')
    .noWhiteSpace('Cannot contain spaces'),
  last_name: yup
    .string()
    .max(60, 'Cannot be longer than 60 characters')
    .required('Required')
    .matches(/^[A-Za-z0-9 ]+$/, 'Cannot contain special characters'),
  ethnic_group: yup.string().required('Required'),
  id_number: yup.string().when('id_type', {
    is: 'P', // When ID type is Passport
    then: yup
      .string()
      .length(9, 'Passport number must be 9 characters')
      .matches(
        /^[A-Za-z0-9]+$/,
        'Passport number must contain only alphanumeric characters',
      )
      .required('Required'),
    otherwise: yup
      .string()
      .length(13, 'ID number must be 13 characters')
      .isValidID()
      .required('Required'),
  }),
  id_type: yup.string().required('Required'),
  gender: yup.string().when('id_type', {
    is: (id_type) => id_type !== 'P', // Only validate gender if ID type is not Passport
    then: yup.string().required('Required').isValidGender(yup.ref('id_number')),
    otherwise: yup.string().required('Required'), // Still required, but no additional validation
  }),
  email: yup.string().email('Must be a valid email').required('Required'),
  cell_phone: yup
    .string()
    .min(10, 'Must be at least 10 digits')
    .max(13, 'Cannot be longer than 13 digits')
    .matches(/^0[0-9]+$/, 'Must start with 0 and contain only digits')
    .required('Required'),
  nationality: yup.string().required('Required'),
  country_of_birth: yup.string().required('Required'),
  postal_address_line_1: yup
    .string()
    .max(50, 'Cannot be longer than 50 characters')
    .required('Required'),
  postal_suburb: yup
    .string()
    .max(50, 'Cannot be longer than 50 characters')
    .required('Required'),
  postal_postal_code: yup
    .string()
    .length(4, 'Must be 4 characters')
    .matches(/^[0-9]+$/, 'Must contain only digits')
    .required('Required'),
  residential_address_line_1: yup
    .string()
    .max(50, 'Cannot be longer than 50 characters')
    .required('Required'),
  residential_suburb: yup
    .string()
    .max(50, 'Cannot be longer than 50 characters')
    .required('Required'),
  residential_postal_code: yup
    .string()
    .length(4, 'Must be 4 characters')
    .matches(/^[0-9]+$/, 'Must contain only digits')
    .required('Required'),
  years_at_residence: yup
    .string()
    .min(0, 'Cannot be less than 0')
    .isValidYAR(yup.ref('id_number'))
    .required('Required'),
  months_at_residence: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue.trim() === '' ? null : value;
    })
    .typeError('Required')
    .max(11, 'Cannot be more than 11')
    .min(0, 'Cannot be less than 0')
    .required('Required'),
  employment_type: yup.string().required('Required'),
  marital_status: yup.string().required('Required'),
  marital_contract: yup.string(),
});

// const titleOptions = [
//   'Mr',
//   'Mrs',
//   'Advocate',
//   'Doctor',
//   'Honorable',
//   'Miss',
//   'Ms',
//   'Pastor',
//   'Professor',
//   'Reverend',
//   'Sir',
// ];

const titleOptions = {
  MR: 'Mr',
  MRS: 'Mrs',
  ADV: 'Advocate',
  DR: 'Doctor',
  HON: 'Honorable',
  MISS: 'Miss',
  MS: 'Ms',
  PAST: 'PAstor',
  PROF: 'Professor',
  REV: 'Reverend',
  SIR: 'Sir',
};

function parseBirthdayFromID(idNumber) {
  if (!idNumber || idNumber.length < 6) {
    return 'Invalid ID Number';
  }

  // Extract the year, month, and day
  var year = parseInt(idNumber.substring(0, 2), 10);
  var month = idNumber.substring(2, 4);
  var day = idNumber.substring(4, 6);

  // Determine the century of the birth year
  var currentYear = new Date().getFullYear();
  var currentYearLastTwoDigits = currentYear % 100;
  var century = year <= currentYearLastTwoDigits ? 2000 : 1900;

  // Construct the full birth year
  year += century;

  // Construct the birthdate in the desired format
  return `${year}-${month}-${day}`;
}

const VehiclePart3 = ({ loadng, setLoading, setError }) => {
  const [stepNumber, setStepNumber] = useContext(Context);
  const [formData, setFormData] = useContext(FormDataContext);
  // const [path] = useContext(PathContext);

  const [married, setMarried] = useState(null);
  const [blogSubscribed, setBlogSubscribed] = useState(false);

  const [vehicleApplication, setVehicleApplication] = useContext(
    VehicleApplicationContext,
  );

  React.useEffect(() => {
    console.log('Part 3');
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const populateForm = () => {
    for (const key in defaultValues) {
      setValue(key + '', defaultValues[key]);
    }
  };

  // useEffect(() => {
  //   sendPostMessage();
  // });

  // useEffect(() => {
  //   console.log(`Changed - ${loadng} - sending post`);
  //   sendPostMessage();
  // }, [loadng]);

  const sendRequest = () => {
    setLoading(true);
    console.log(`Changed - sending post`);
    sendPostMessage();
    let reqData = JSON.parse(JSON.stringify(formData));
    delete reqData.customerProfile.ethnicGroup;
    delete reqData.customerProfile.nationality;
    delete reqData.customerProfile.countryOfBirth;
    delete reqData.customerProfile.maritalContractCode;
    // delete reqData.customerProfile.residentialAddress.yearsAtResidence;
    // console.log('REQ DATA:', reqData);
    console.log('Part 3:', reqData);
    sendFinanceRequest(reqData)
      .then((res) => {
        // console.log(res);
        setLoading(false);
        setFormData((curr) => {
          if (res.fieldErrors.length) {
            return {
              ...curr,
              fieldErrors: res.fieldErrors,
            };
          } else {
            return {
              ...curr,
              financeResponse: res.preApproval.preApprovalResults,
              financeMatrix: res.scoreGrid,
              preApprovalId: res.preApproval.preApprovalId,
              totalAffordableAmount: res.preApproval.totalAffordableAmount,
              monthlyInstallment: res.financeDetails.monthlyInstallment, //NEW
            };
          }
        });
        setStepNumber(stepNumber + 1);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        console.log('Error details:', e);
      });
  };

  const onSubmit = async (data) => {
    console.log(data);
    let curr = formData;
    let customerProfile = {
      title: data.title,
      firstName: data.first_name,
      lastName: data.last_name,
      gender: data.gender,
      ethnicGroup: data.ethnic_group,
      nationality: data.nationality,
      countryOfBirth: data.country_of_birth,
      // dateOfBirth: data.date_of_birth,
      dateOfBirth: parseBirthdayFromID(data.id_number),
      occupation: {
        customerType: data.employment_type,
      },
      identification: {
        idNumber: data.id_number,
        idType: data.id_type,
      },
      contactMethod: {
        email: data.email,
        cellPhone: data.cell_phone,
      },
      postalAddress: {
        postalLine1: data.postal_address_line_1,
        suburb: data.postal_suburb,
        postalCode: data.postal_postal_code,
      },
      residentialAddress: {
        street: data.residential_address_line_1,
        suburb: data.residential_suburb,
        postalCode: data.residential_postal_code,
        durationMonth: data.months_at_residence,
        durationYear: parseInt(data.years_at_residence),
      },
      maritalStatus: data.marital_status,
      maritalContractCode: data.marital_contract,
    };
    curr.customerProfile = customerProfile;
    setFormData(curr);

    const contact = {
      email: data.email,
      firstname: data.first_name,
      lastname: data.last_name,
      fastapp_blog_subscribed: blogSubscribed,
      fastapp_vehicle: vehicleApplication,
    };

    try {
      const res = await axios.post(
        'https://us-central1-fasttrack-client.cloudfunctions.net/api/contact',
        contact,
      );
      console.log('Contact response:', res);
    } catch (error) {
      console.log(error);
    }

    sendRequest();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {/* <h2 className="text-3xl md:px-8 w-full uppercase font-bold my-12 text-suzBlue">
        Personal information
      </h2> */}
      <FormSection>
        <FormHalfCol>
          <Select
            register={register}
            label="Title"
            errorMessage={errors.title?.message}
            options={titleOptions}
            required
          />
          <Input
            label="First name"
            register={register}
            errorMessage={errors.first_name?.message}
            required
          />
          <Input
            label="Last name"
            register={register}
            errorMessage={errors.last_name?.message}
            required
          />
          <Select
            register={register}
            label="Ethnic Group"
            errorMessage={errors.ethnic_group?.message}
            options={ethnicGroups}
            required
          />
          <Input
            label="ID Number"
            register={register}
            errorMessage={errors.id_number?.message}
            required
          />
          <Select
            register={register}
            label="ID Type"
            errorMessage={errors.id_type?.message}
            options={{ I: 'ID Document', P: 'Passport' }}
            required
          />
        </FormHalfCol>
        <FormHalfCol>
          {/* <Input
            type="date"
            label="Date of Birth"
            register={register}
            errorMessage={errors.date_of_birth?.message}
            required
          /> */}
          <Select
            label="Gender"
            register={register}
            errorMessage={errors.gender?.message}
            options={{ M: 'Male', F: 'Female' }}
            required
          />
          <Input
            type="email"
            label="Email"
            register={register}
            errorMessage={errors.email?.message}
            required
          />
          <Input
            label="Cell Phone"
            register={register}
            errorMessage={errors.cell_phone?.message}
            required
          />
          <Select
            register={register}
            label="Nationality"
            errorMessage={errors.nationality?.message}
            options={{ ZA: 'South African', NA: 'Other' }}
            required
          />
          <Select
            register={register}
            label="Country of Birth"
            errorMessage={errors.country_of_birth?.message}
            options={{ ZA: 'South Africa', NA: 'Other' }}
            required
          />
        </FormHalfCol>
      </FormSection>
      <FormSection>
        <FormHalfCol>
          <Input
            type="text"
            label="Postal Address Line 1"
            register={register}
            errorMessage={errors.postal_address_line_1?.message}
            required
          />
          <Input
            type="text"
            label="Suburb"
            register={register}
            errorMessage={errors.postal_suburb?.message}
            name="postal_suburb"
            required
          />
          <Input
            type="text"
            label="Postal Code"
            register={register}
            errorMessage={errors.postal_postal_code?.message}
            name="postal_postal_code"
            required
          />
        </FormHalfCol>
        <FormHalfCol>
          <Input
            type="text"
            label="Residential Address Line 1"
            register={register}
            errorMessage={errors.residential_address_line_1?.message}
            required
          />
          <Input
            type="text"
            label="Suburb"
            register={register}
            errorMessage={errors.residential_suburb?.message}
            name="residential_suburb"
            required
          />
          <Input
            type="text"
            label="Postal Code"
            register={register}
            errorMessage={errors.residential_postal_code?.message}
            name="residential_postal_code"
            required
          />
          <Input
            type="number"
            label="Years at Residence"
            register={register}
            errorMessage={errors.years_at_residence?.message}
            required
          />
          <Input
            type="number"
            label="Months at Residence"
            register={register}
            errorMessage={errors.months_at_residence?.message}
            required
          />
        </FormHalfCol>
      </FormSection>
      <FormSection>
        <FormHalfCol>
          <Select
            register={register}
            label="Employment Type"
            errorMessage={errors.employment_type?.message}
            options={{ '01': 'Employed', 14: 'Self-Employed' }}
            required
          />
        </FormHalfCol>
        <FormHalfCol>
          <Select
            register={register}
            label="Marital Status"
            errorMessage={errors.marital_status?.message}
            setValue={setMarried}
            options={{
              U: 'Unmarried',
              M: 'Married',
              W: 'Widowed',
              D: 'Divorced',
              S: 'Separated',
            }}
            required
          />
          {married && married !== 'U' && (
            <Select
              register={register}
              required
              label="Marital Contract"
              errorMessage={errors.marital_contract?.message}
              options={{
                ANC: 'ANC',
                COP: 'COP',
                TRI: 'TRI',
                ACC: 'ACC',
                OCP: 'OCP',
              }}
            />
          )}
        </FormHalfCol>
      </FormSection>
      <div className="text-left w-4/5 mx-auto">
        <p>
          By clicking submit below, you consent to allow Suzuki Auto South
          Africa to store and process the personal information submitted above
          to provide you with the content you requested. Suzuki Auto South
          Africa will not store any of your income or financial information.
        </p>
        <div className="mt-8">
          <p>Would you like to hear more from us?</p>
          <label for="blog-subscribe">
            <input
              className="mr-4"
              type="checkbox"
              id="blog-subscribe"
              name="blog-subscribe"
              onChange={(e) => setBlogSubscribed(e.target.checked)}
            />
            Sign up to receive our latest offers and updates.
          </label>
        </div>
      </div>
      <div className="flex justify-center mt-16 w-full">
        <Input type="submit" label="Next" />
      </div>

      {/* <div className="mx-4">
        <Button text="POPULATE (Demo)" action={populateForm} />
      </div> */}
    </form>
  );
};

export default VehiclePart3;
